import "./App.css";

import React, { useEffect, useState } from "react";

import QRCode from "./components/QRCode";

function App() {
  const [qrCodeData, setQrCodeData] = useState({
    imageUrl:
      "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://example.com",
    label: "ebn el balad",
  });

  useEffect(() => {
    try {
      // Parse URL query parameters
      const urlParams = new URL(window.location.href);
      const params = urlParams.searchParams;

      // Get uuid if it exists
      const uuid = params.get("uuid");
      if (uuid) {
        setQrCodeData((prevData) => ({
          ...prevData,
          imageUrl: `https://api.qrserver.com/v1/create-qr-code/?size=210x210&data=https://www.gotrato.com/link/${uuid}`,
        }));
      } else {
        // Get encoded imageUrl if it exists
        const encodedImageUrl = params.get("imageUrl");
        if (encodedImageUrl) {
          // Decode the imageUrl parameter
          const decodedImageUrl = decodeURIComponent(encodedImageUrl);
          setQrCodeData((prevData) => ({
            ...prevData,
            imageUrl: decodedImageUrl,
          }));
        }
      }

      // Get label if it exists
      const label = params.get("label");
      if (label) {
        setQrCodeData((prevData) => ({
          ...prevData,
          label: label,
        }));
      }
    } catch (error) {
      console.error("Error parsing URL parameters:", error);
    }
  }, []); // Empty dependency array is fine since we're only running this once on mount

  return (
    <div className="App">
      <div className="qr-code-display">
        <QRCode imageUrl={qrCodeData.imageUrl} label={qrCodeData.label} />
      </div>
    </div>
  );
}

export default App;
